import { render, staticRenderFns } from "./VisibilidadReducida.vue?vue&type=template&id=1b77505c"
import script from "./VisibilidadReducida.vue?vue&type=script&lang=js"
export * from "./VisibilidadReducida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports